(function(){
  if(window.__d22pdp) return; window.__d22pdp=true;
  function fmt(d){return d.toLocaleDateString(document.documentElement.lang||undefined,{weekday:'short',day:'numeric',month:'short'})}
  function addDays(n,biz){var d=new Date(),i=0;while(i<n){d.setDate(d.getDate()+1);var w=d.getDay();if(!biz||(w!==0&&w!==6))i++}return d}
  function eta(){document.querySelectorAll('[data-d22-delivery]').forEach(function(el){
    var a=+el.dataset.min,b=+el.dataset.max,biz=el.dataset.business==='true',t=el.querySelector('[data-d22-eta]');
    if(t&&b>=a&&a>0) t.textContent=fmt(addDays(a,biz))+' \u2013 '+fmt(addDays(b,biz));
  })}
  function sticky(){
    var bar=document.querySelector('[data-d22-sticky]'); if(!bar||bar.dataset.ready) return;
    var info=document.querySelector('.product__info-container');
    var form=document.querySelector('product-form');
    bar.dataset.ready='1';
    var add=form&&form.querySelector('button[name=add]'), buy=form&&form.querySelector('[data-d22-buynow]');
    var anchor=add||(info&&info.querySelector('.shopify-app-block,[id^="shopify-block-"]'));
    var ba=bar.querySelector('[data-d22-sticky-add]'), bb=bar.querySelector('[data-d22-sticky-buy]'), bp=bar.querySelector('[data-d22-sticky-price]');
    function sync(){
      var p=document.querySelector('.product .price-item--last'); if(p&&bp) bp.textContent=p.textContent.trim();
      ba.disabled=bb.disabled=!!(add&&add.disabled);
    }
    function app(){var d=window.d22;return d&&d.appActive()?d.foreignBuy(info):null}
    ba.addEventListener('click',function(){if(add) add.click()});
    bb.addEventListener('click',function(){
      var f=app(); if(f){f.click();return}
      if(buy&&buy.style.display!=='none') buy.click(); else if(add) add.click();
    });
    if('IntersectionObserver' in window&&anchor){
      new IntersectionObserver(function(en){bar.classList.toggle('is-on',!en[0].isIntersecting);sync()},{threshold:0}).observe(anchor);
    }
    var root=(form&&form.closest('.product'))||document.querySelector('.product')||document.body;
    new MutationObserver(sync).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled']});
    sync();
  }
  eta(); sticky();
  document.addEventListener('shopify:section:load',function(){eta();sticky()});
})();
